import Box from "@mui/material/Box";
import Stack from '@mui/material/Stack';

export const VideoSection = ({ finishedLoading }) => {
   const url = "https://www.youtube.com/embed/Fl0Ky_8K7Wo?mute=1";
   return (
      <>
         <Box className="video-sec-web" sx={{ flexGrow: 1 }}>
            <div style={{
               display: 'flex',
               width: '100%',
               height: '100%',
               background: "linear-gradient(90deg, #092CA8, #00c2ff)",
               flexDirection: 'column',
               paddingBottom: "5%",
            }}>
               <h1 style={{ textAlign: 'center', fontWeight: '900', color: 'white', margin: '2.5% 0% 2.5% 0%' }}>MEET THE RIGHT PEOPLE</h1>
               {finishedLoading && <div style={{
                  position: "relative",
                  width: "50%",
                  height: "auto",
                  margin: "0 auto",
                  paddingTop: "26.5%",
               }}>
                  <iframe style={{
                     position: "absolute",
                     top: 0,
                     left: 0,
                     bottom: 0,
                     right: 0,
                     width: "100%",
                     height: "100%",
                     border: "none",
                  }}
                     src={url}
                     title="YouTube video player" frameBorder="0"
                     allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen
                  >
                  </iframe>
               </div>}
            </div>
         </Box>

         <Stack className="video-sec-mobile"
            style={{
               background: "linear-gradient(90deg, #092CA8, #00c2ff)",
               paddingBottom: "2.5%",
            }}>
            <h1 style={{ textAlign: 'center', fontWeight: '900', color: 'white', margin: '2.5% 0% 2.5% 0%' }}>MEET THE RIGHT PEOPLE</h1>
            <div style={{
               position: "relative",
               width: "75%",
               height: "auto",
               margin: "0 auto",
               paddingTop: "39.7%",
            }}>
               <iframe style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  bottom: 0,
                  right: 0,
                  width: "100%",
                  height: "100%",
                  border: "none",
               }}
                  src={url}
                  title="YouTube video player"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen
               >
               </iframe>
            </div>
         </Stack>
      </>
   );
};

